import "@/App.css";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Sobre from "@/components/sections/Sobre";
import WhatIs from "@/components/sections/WhatIs";
import DiagnosticoTratamento from "@/components/sections/DiagnosticoTratamento";
import Caminho from "@/components/sections/Caminho";
import Depoimentos from "@/components/sections/Depoimentos";
import Convenios from "@/components/sections/Convenios";
import FAQ from "@/components/sections/FAQ";
import Contato from "@/components/sections/Contato";
import Footer from "@/components/sections/Footer";
import WhatsAppFloat from "@/components/sections/WhatsAppFloat";
import BackToTop from "@/components/sections/BackToTop";
import ProgressBar from "@/components/sections/ProgressBar";

function App() {
  return (
    <div className="App font-opensans">
      <ProgressBar />
      <Header />
      <main>
        <Hero />
        <Sobre />
        <WhatIs />
        <DiagnosticoTratamento />
        <Caminho />
        <Depoimentos />
        <Convenios />
        <FAQ />
        <Contato />
      </main>
      <Footer />
      <WhatsAppFloat />
      <BackToTop />
    </div>
  );
}

export default App;
